import { digObject } from '@domain-group/javascript-utils'
import { useNumericParams } from '@domain-group/react-hooks'

import useSelector from '@hooks/useSelector'

function useCampaignSelector() {
  const { campaignId } = useNumericParams()

  const { campaigns, agencies } = useSelector(reduxState => reduxState.entities)

  const campaign = campaigns[campaignId] || {}

  const { agency_id } = campaign

  const agency = agencies[agency_id] || {}
  const agencyPermissions = digObject(agency, 'current_user_permissions.agency')

  return {
    agency,
    agencyPermissions,
    campaign,
  }
}

export default useCampaignSelector
